



















import Vue from 'vue'
import { mapState } from 'vuex'
import { State, Action, Getter } from 'vuex-class'
import Component from 'vue-class-component'
import { ContextState, User, Config, DidInitAuth } from '@/store/context/contextTypes'
import { transformObjectToQuery, deviceIdExists } from '@/utils/helpers'
import { createDidCodeVerification, constructDIDProviderUrl, generateDidClaims } from '@/utils/didHelpers'
import JavascriptAPI from '@/utils/JavascriptAPI'
const _CONTEXT_: string = 'context'

@Component({
  props: {
    provider: { type: String, required: true }
  },
  computed: {
    ...mapState({
      user: (state: any): any => state.context.user,
      config: (state: any): User => state.context.config,
      settings: (state: any): User => state.context.settings,
      editUserData: (state: any): User => state.context.editUserData,
      identifyWizardStep: (state: any): User => state.context.identifyWizardStep,
      didInitialAuth: (state: any): User => state.context.didInitialAuth,
      manualUserRegister: (state: any): boolean => state.context.manualUserRegister,
      userDeviceExists: (state: any): User => state.context.userDeviceExists,
      userWizardData: (state: any): User => state.context.userWizardData
    })
  },
  watch: {
    async provider (provider, previousProvider) {
      if (provider !== previousProvider && provider === 'manual') {
        // Regular providers deal with their DID authentication in that component. The manual register is a special one
        // We manually trigger the init auth flow from here when manual is selected. We also do this on mounted for manual register
        await createDidCodeVerification()
      }
    },
    manualUserRegister (triggerNewUser, previous) {
      if (triggerNewUser && this.editUserData && !this.user) {
        const claims = generateDidClaims(this.editUserData, this.config.country)
        const encodedClaims = encodeURIComponent(JSON.stringify(claims))
        let url = constructDIDProviderUrl(
          {
            provider: 'manual',
            display: 'inline',
            country: this.config.country
          }
        )
        url += `&claims=${encodedClaims}`
        url += `&code_challenge_method=S256&code_challenge=${this.didInitialAuth.didCodeChallenge}`
        if (deviceIdExists() && this.settings.rememberDevice) {
          const deviceId = localStorage.getItem('piq_dId')
          url += `&device_id=${deviceId}`
        }

        const iframe = this.$refs['didRegisterManualUser']
        iframe.onload = () => {
          JavascriptAPI.__REPORT_CLIENT_HEIGHT__()
          iframe.src = ''
          this.setTriggerUserManualRegister(false) // reset

          setTimeout(() => {
            if (this.isLoading) {
              // means the request did not made it and our auth-flow was not triggered. Meaning loading is still true
              // can be that their post message targets the wrong origin (whitelisted localhost:4000 + https://pay.paymentiq.io)
              // check response of the request - should be a html with a postMessage. The origin is printed out there
              this.setIsLoading(false)
              this.setError({ key: 'main', error: 'failed_did_manual_register' })
            }
          }, 5000)
        }
        iframe.src = url
      }
    },
    didInitialAuth (currentAuth: DidInitAuth | null, previousAuth: DidInitAuth | null) {
      if (this.userDeviceExists) {
        if (currentAuth.didCodeVerifier && currentAuth.didCodeChallenge) {
          // Did lets you check deviceId + one property (email, zip nationalId for example)
          // The Checkout client was built as a wizard, enter one field, if don't get a match
          // present the next field, and for every new field we would just add the value to the object
          // But with DID we only want the latest property and only to pass that to DID.
          let manualData = this.userWizardData
          const previousField = this.config.identifyFields[this.identifyWizardStep]
          if (!manualData[previousField]) {
            // Did we end up here without a value to search with? Return
            return
          }
          manualData = {
            [previousField]: manualData[previousField]
          }
          const data = transformObjectToQuery(manualData)
          let url = constructDIDProviderUrl(
            {
              provider: 'device',
              display: 'inline',
              country: this.config.country
            }
          )
          url += `&${data}`
          url += `&code_challenge_method=S256&code_challenge=${currentAuth.didCodeChallenge}`

          if (deviceIdExists() && this.settings.rememberDevice) {
            const deviceId = localStorage.getItem('piq_dId')
            url += `&device_id=${deviceId}`
          }

          const iframe = this.$refs['existingDidUser']
          iframe.onload = () => {
            JavascriptAPI.__REPORT_CLIENT_HEIGHT__()
            setTimeout(() => {
              if (this.isLoading) {
                // means the request did not made it and our auth-flow was not triggered. Meaning loading is still true
                // can be that their post message targets the wrong origin (whitelisted localhost:4000 + https://pay.paymentiq.io)
                // check response of the request - should be a html with a postMessage. The origin is printed out there
                this.setIsLoading(false)
                this.setError({ key: 'main', error: 'failed_authenticate_did' })
              }
            }, 5000)
          }
          console.log('############### IFRAME LISTENER URL:')
          console.log(url)
          iframe.src = url
        }
      }
    }
  }
})
export default class DidIframeListeners extends Vue {
  config?: Config
  user?: User
  manualUserRegister: boolean
  @State('context') context: ContextState
  @Action('setTriggerUserManualRegister', { namespace: _CONTEXT_ }) setTriggerUserManualRegister: any

  mounted () {
    if (this.config.identifyProvider === 'manual') {
      // We do this otherwise is the provider handler (IdentifyRedirectContent). But DID manual registration requires this initial authstep right away
      setTimeout(async () => {
      // We risk calling this before the eventListener has registered in the Integration-script. This needs to be resolved in a better way.
        await createDidCodeVerification()
      }, 500)
    }
  }
}
